module.exports = __webpack_public_path__ + "media/images/proof_links/megogo-f7e2b570375bc3bdcb266e1ced2e2d29.svg";